import { render, staticRenderFns } from "./VerVendedor.vue?vue&type=template&id=b2f07d1c&scoped=true&"
import script from "./VerVendedor.vue?vue&type=script&lang=js&"
export * from "./VerVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f07d1c",
  null
  
)

export default component.exports